import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import type { ReactNode } from 'react';

type Tone = 'info' | 'success' | 'warning' | 'error';

const toneStyles: Record<Tone, { wrap: string; icon: ReactNode }> = {
  info: {
    wrap: 'bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-900',
    icon: <Info className="h-5 w-5 shrink-0" />,
  },
  success: {
    wrap:
      'bg-green-50 text-green-800 border-green-200 dark:bg-green-950/40 dark:text-green-300 dark:border-green-900',
    icon: <CheckCircle2 className="h-5 w-5 shrink-0" />,
  },
  warning: {
    wrap:
      'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900',
    icon: <AlertTriangle className="h-5 w-5 shrink-0" />,
  },
  error: {
    wrap: 'bg-red-50 text-red-800 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-900',
    icon: <XCircle className="h-5 w-5 shrink-0" />,
  },
};

export function Alert({ tone = 'info', children }: { tone?: Tone; children: ReactNode }) {
  const styles = toneStyles[tone];
  return (
    <div role={tone === 'error' ? 'alert' : 'status'} className={`flex items-start gap-2.5 rounded-xl border px-4 py-3 text-sm ${styles.wrap}`}>
      {styles.icon}
      <div className="min-w-0">{children}</div>
    </div>
  );
}
